import _ from 'lodash'
import {DFS} from "../../../../helpers";
import SimpExp from '../../../../helpers/external/simpexp'

const DEFAULT_MODEL = [
  {
    field: 'recipient_number',
    type: 'string',
    validation: (value, getStore) => {
      const {mask} = getStore().app.product_data;
      const pattern = DFS(new SimpExp(mask).gen('9'));
      if(!(value && pattern)) return false;

      return value.length === pattern.length
    }
  },
  {
    field: 'sender_number',
    type: 'string'
  },
  {
    field: 'original_amount',
    type: 'number'
  },
  {
    field: 'customer_id',
    type: 'number'
  }
];

export function getData(getStore) {
  const applicationData = getStore().app && getStore().app.x_data;
  if(!applicationData) {
    console.error('ApplicationData not found');
    return false;
  }
  const result = {};

  _.each(DEFAULT_MODEL, (o) => {
    result[o.field] = applicationData[o.field];
  });

  return result;
}

export function validator(getStore, extraModel = null) {
  const applicationData = getStore().app && getStore().app.x_data;
  if(!applicationData) {
    console.error('ApplicationData not found');
    return false;
  }

  const MODEL = _.compact(_.concat(DEFAULT_MODEL, extraModel));

  const result = _.reduce(MODEL, (prevStep, nextStep) => {
    const value = applicationData[nextStep.field];
    const extraValidation =  nextStep.validation ? nextStep.validation(value, getStore) : true;

    const isValid = !!(value && typeof value === nextStep.type && extraValidation);

     // console.log(nextStep.field, isValid);

    return prevStep && isValid
  }, true);

  // console.log('Validation', MODEL, extraModel, result);

  return result
}



// WEBPACK FOOTER //
// ./src/components/Applications/InternationalPhonereload/models/transaction.js